import { NavLink } from "react-router-dom"
import { useEffect } from "react"
import { SITE_INFO } from '../configs/info'

export default function Privacy() {
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Header Section */}
            <section className="bg-[linear-gradient(177.6deg,_rgba(180,0,0,1)_15.3%,_rgba(80,0,0,1)_91.3%)] text-white py-6 sm:py-8 md:py-10">
                <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto pt-8">
                    <div className="text-center mb-4">
                        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-pink-100 text-xs md:text-sm">
                            <span className="inline-block w-2 h-2 rounded-full bg-pink-400"></span>
                            {SITE_INFO.siteName}
                        </span>
                    </div>
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight bg-gradient-to-r from-white via-pink-100 to-orange-100 bg-clip-text text-transparent drop-shadow-lg">Política de Privacidad</h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mt-3">
                        <span className="text-sm text-white/80">
                            <NavLink
                                to="/"
                                className="transition-all duration-500 hover:text-pink-400"
                                onClick={scrollToTop}
                            >
                                Inicio
                            </NavLink> / <span className="text-white/60">Política de Privacidad</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-6 md:py-8 min-h-[80vh] comment-pricing">
                <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                    <div className="space-y-6">
                        {/* Section 1 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">1. Información que recopilamos</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Recopilamos la información que usted nos proporciona directamente, como su nombre,
                                dirección de correo electrónico e información de pago cuando se suscribe a nuestros servicios IPTV.
                                Esta información es necesaria para proporcionar nuestros servicios y procesar sus pagos.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">2. Cómo utilizamos su información</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Utilizamos su información para proporcionar, mantener y mejorar nuestros servicios IPTV,
                                procesar sus pagos, comunicarnos con usted acerca de su cuenta y enviarle
                                actualizaciones importantes sobre nuestros servicios.
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">3. Compartir su información</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                No vendemos, intercambiamos ni alquilamos su información personal a terceros.
                                Podemos compartir su información únicamente con nuestros proveedores de servicios
                                de pago para procesar sus transacciones, y solo en la medida necesaria.
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">4. Seguridad de sus datos</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Implementamos medidas de seguridad apropiadas para proteger su información
                                personal contra el acceso no autorizado, la alteración, divulgación o destrucción.
                                Sus datos están encriptados y almacenados de forma segura.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">5. Sus derechos</h2>
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Usted tiene derecho a acceder, corregir o eliminar su información personal
                                en cualquier momento. También puede oponerse al procesamiento de sus datos o
                                solicitar la portabilidad de su información.
                            </p>
                        </div>

                        {/* Section 6 */}
                        <div className="p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 text-white">
                            <h2 className="text-xl md:text-2xl font-extrabold mb-3">6. Contáctenos</h2>
                            <p className="text-sm md:text-base leading-relaxed mb-4 text-white/80">
                                Para cualquier pregunta sobre esta política de privacidad o para ejercer sus derechos,
                                puede contactarnos a través de:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm md:text-base text-white/90">
                                <li>Correo electrónico: <span className="text-pink-300">contact@tvcielo.com</span></li>
                                <li>
                                    WhatsApp:{" "}
                                    <a
                                        href="https://wa.me/33644657251"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-pink-300 underline hover:text-pink-400"
                                    >
                                        Haga clic aquí para contactarnos
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="mt-10 pt-6 border-t border-white/10 text-white">
                            <p className="text-sm md:text-base leading-relaxed text-white/80">
                                Gracias por elegir {SITE_INFO.siteName}. Estamos orgullosos de garantizar su privacidad y de
                                ofrecerle un servicio de alta calidad sin comprometer su seguridad o anonimato.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}